import {
  required,
  confirmed,
  length,
  email,
  is,
  between,
  max,
} from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import { localize } from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import de from "vee-validate/dist/locale/de.json";

extend("required", required);
extend("email", email);
extend("confirmed", confirmed);
extend("length", length);
extend("max", max);
extend("is", is);
extend("between", between);

localize({
  de,
  en,
});
